const s = "agent", t = "capitalOne", a = "luma", o = "littlewoods", n = "ocean", e = "postOffice", c = "thinkMoney", O = "very", l = "ASOS", r = [
  s,
  l,
  t,
  o,
  a,
  n,
  e,
  c,
  O
], A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AGENT: s,
  ASOS: l,
  CAPITAL_ONE: t,
  LITTLEWOODS: o,
  LUMA: a,
  OCEAN: n,
  POST_OFFICE: e,
  THINK_MONEY: c,
  VERY: O,
  default: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as A,
  t as C,
  o as L,
  n as O,
  e as P,
  c as T,
  O as V,
  r as a,
  A as b,
  l as c,
  a as d
};
